import { DomainThemeOverrides } from "./types";

/**
 * Add whitelabels here. A key matches the root domain itself and every
 * subdomain below it. Only values that differ from the default are needed.
 *
 * Example:
 *
 * "example.nl": {
 *     urls: {
 *         auth: "https://login.example.nl",
 *         account: "https://account.example.nl",
 *         office: "https://office.example.nl",
 *     },
 *     brand: {
 *         companyName: "Example B.V.",
 *         shortName: "Example",
 *         productName: "Portal",
 *     },
 *     assets: {
 *         logoDark: "/themes/example/logo-dark.svg",
 *         logoLight: "/themes/example/logo-light.svg",
 *         // headerLogoDark/headerLogoLight and the small variants default
 *         // to these logos unless they are overridden separately.
 *         favicon: "/themes/example/favicon.ico",
 *     },
 *     colors: {
 *         primary: "#7c3aed",
 *         // Hover/focus and portal variants are derived from primary unless
 *         // they are explicitly overridden here as well.
 *     },
 *     contact: { supportEmail: "support@example.nl" },
 * }
 */
export const domainThemeOverrides: DomainThemeOverrides = {
    "localhost": {
        urls: {
            auth: "http://auth.localhost:3000",
            account: "http://account.localhost:3000",
            office: "http://localhost:3000",
        },
        domain: {
            protocol: "http",
        },
    },
    "cfrgroup.nl": {
        urls: {
            auth: "https://login.cfrgroup.nl",
            account: "https://mijn.cfrgroup.nl",
            office: "https://office.cfrgroup.nl",
        },
        brand: {
            companyName: "CFR-Group B.V.",
            shortName: "CFR-Group",
            productName: "Office",
        },
        assets: {
            logoDark: "/themes/cfr-group/logo-dark.svg",
            logoLight: "/themes/cfr-group/logo-light.svg",
            headerLogoDark: "/themes/cfr-group/logo-dark.svg",
            headerLogoLight: "/themes/cfr-group/logo-light.svg",
            logoSmallDark: "/themes/cfr-group/logo-small-dark.svg",
            logoSmallLight: "/themes/cfr-group/logo-small-light.svg",
            favicon: "/themes/cfr-group/logo-small-dark.svg",
            appleTouchIcon: "/themes/cfr-group/logo-small-dark.svg",
            pwaIcon192: "/themes/cfr-group/logo-small-dark.svg",
            pwaIcon512: "/themes/cfr-group/logo-small-dark.svg",
        },
        contact: {
            supportEmail: "support@cfrgroup.nl",
        },
    },
};
